module.exports = __webpack_public_path__ + "img/image-14.2c9d57aa.svg";